import { defineComponent as _defineComponent } from 'vue'
import {useTranslations} from "@/hooks/useTranslations";
import Package from "@/models/Subscriptions/SubscriptionPackages/Package";
import {SubscriptionRecurrenceType} from "@/models/Subscriptions/SubscriptionRecurrenceType";

type PackageDetailsProps = {
  selectedPackage: Package;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PackageDetails',
  props: {
    selectedPackage: null
  },
  setup(__props: any) {



const translations = useTranslations();

return { __sfc: true,translations, SubscriptionRecurrenceType }
}

})